<template>
  <div id="app" class="homeBg">
    <Home />
  </div>
</template>


<script>
import Home from "./view/Home";
export default {
  name: "App",
  components: {
    Home,
  },
};
</script>


<style lang="css">
@import url("../src/styles/atom-one-dark.css");
@import url("../src/styles/github-markdown.css");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  width: 100%;
  text-align: center;
  transform-style: preserve-3d;
  padding: 2vh;
  box-sizing: border-box;
}

html,
body,
li,
ul {
  padding: 0;
  margin: 0;
}
li,
ul {
  list-style: none;
}

html {
  color: #2c3e50;
}

.boxBg {
  background-image: linear-gradient(#e0eafc, #cfdef3);
  border-radius: 20px;
}

.homeBg {
  background-image: linear-gradient(#4568dc, #b06ab3);
}

.F-SC-C {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.F-SAFS {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}

pre {
  text-align: start;
}

h3 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
  padding: 4px 8px;
  display: block;

  border-radius: 0px 0px 20px 20px;
  color: #ffebd1;
  font-weight: 600;
}
.pointer {
  cursor: pointer;
}
.button1 {
  padding: 4px 8px;
  display: block;

  color: #ffebd1;
  font-weight: 600;
}

.red {
  background-color: #fd5457;
}

.green {
  background-color: #50ae55;
}

.orange {
  background-color: #fec02f;
}

.blue {
  background-color: #4568dc;
}
</style>
